import { useCallback, useRef, useState } from "react";

/**
 * Drag-n-drop файлов на элемент.
 * onFile(file) — колбэк с первым подходящим файлом.
 * accept — префикс MIME-типа, например "video/".
 */
export const useFileDrop = ({
  onFile,
  accept = "video/",
  disabled = false,
}) => {
  const [isDragActive, setIsDragActive] = useState(false);
  // Счётчик нужен, потому что dragenter/dragleave срабатывают
  // на каждом вложенном элементе и подсветка иначе мигает
  const dragCounter = useRef(0);

  const handleDragEnter = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (disabled) return;
      dragCounter.current += 1;
      if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
        setIsDragActive(true);
      }
    },
    [disabled]
  );

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current -= 1;
    if (dragCounter.current === 0) setIsDragActive(false);
  }, []);

  const handleDragOver = useCallback((e) => {
    e.preventDefault(); // обязательно, иначе браузер откроет файл
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback(
    (e) => {
      console.log(e);
      e.preventDefault();
      e.stopPropagation();
      dragCounter.current = 0;
      setIsDragActive(false);
      if (disabled) return;

      const files = Array.from(e.dataTransfer.files || []);
      const file = files.find((f) => f.type.startsWith(accept));
      if (file) onFile(file);
    },
    [onFile, accept, disabled]
  );

  return {
    isDragActive,
    dropHandlers: {
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      onDragOver: handleDragOver,
      onDrop: handleDrop,
    },
  };
};
